<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
				<template slot="BodyFormLoad">
					<div class="container-fluid">
						<form id="FormNotaCredito" role="form" method="post" autocomplete="off" onSubmit="return false">
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
									<label class="form-label" for="NombreCliente">Cliente</label>
									<input type="text" v-model="objNotaCredito.NombreCliente" class="form-control" id="NombreCliente" placeholder="Ingresar Nombre Cliente" readonly/>
									<CValidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'*'+errorvalidacion.IdCliente[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
									<label class="form-label" for="RFC">RFC</label>
									<input type="text" v-model="objNotaCredito.RfcCliente" class="form-control" id="RFC" placeholder="Ingresar RFC" readonly />
								</div>

								<div v-if="(objNotaCredito.IdNotaCredito>0)" class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="Folio">Folio Crédito</label>
									<input type="text" class="form-control" id="Folio" placeholder="Ingresar Folio" :value="objNotaCredito.Folio+' - '+objNotaCredito.Serie" readonly />
								</div>

								<div v-else class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="Folio">Folio Factura</label>
									<input type="text" class="form-control" id="Folio" placeholder="Ingresar Folio" :value="objNotaCredito.FolioFactura" readonly />
								</div>

								<div v-if="(objNotaCredito.IdNotaCredito==0)" class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 text-end">
									<label class="form-label" for="Folio">Buscar # Factura</label><br>
									<button type="button" @click="AbrirModalFacturas()" class="btn btn-primary">
										<i class="fa fa-search"></i> Factura
									</button>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
									<span>Regimen Fiscal: <b>{{objNotaCredito.RegimenFiscalCliente}}</b></span><br>
									<span>Calle: <b>{{objNotaCredito.CalleCliente}}</b>, N° Ext. <b>{{objNotaCredito.NumExtCliente}}</b>, Colonia: <b>{{objNotaCredito.ColoniaCliente}}</b>, Código Postal: <b>{{objNotaCredito.CPCliente}}</b></span><br>
									<span>Pais: <b>{{objNotaCredito.PaisCliente}}</b>, Estado: <b>{{objNotaCredito.EstadoCliente}}</b>, Municipio: <b>{{objNotaCredito.CiudadCliente}}</b></span>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label for="CondicionesPago">Condición de pago</label>
									<select v-model="objNotaCredito.CondicionesPago" class="form-control form-select" id="CondicionesPago">
										<option value="">Seleccione una opción</option>
										<option value="CONTADO">Contado</option>
										<option value="CREDITO">Crédito</option>
									</select>
									<CValidation v-if="this.errorvalidacion.CondicionesPago" :Mensaje="'*'+errorvalidacion.CondicionesPago[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label for="MetodoPago">Método de pago:</label>
									<select v-model="objNotaCredito.MetodoPago" class="form-control form-select" id="MetodoPago">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaMetodoPago" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.MetodoPago" :Mensaje="'*'+errorvalidacion.MetodoPago[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label for="FormaPago">Forma de pago</label>
									<select v-model="objNotaCredito.FormaPago" class="form-control form-select" id="FormaPago">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaFormaPago" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.FormaPago" :Mensaje="'*'+errorvalidacion.FormaPago[0]"/>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label class="" for="UsoCfdi">Uso CFDI</label>
									<select v-model="objNotaCredito.UsoCfdi" class="form-control form-select" id="UsoCfdi">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaUsodeCfdi" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.UsoCfdi" :Mensaje="'*'+errorvalidacion.UsoCfdi[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label class="" for="Moneda">Moneda</label>
									<select v-model="objNotaCredito.Moneda" class="form-control form-select" id="Moneda">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaMonedas" :key="index" :value="item.Clave">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.Moneda" :Mensaje="'*'+errorvalidacion.Moneda[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label class="" for="TipoCambio">Tipo de Cambio</label>
									<input type="text" v-model="objNotaCredito.TipoCambio" @input="$number_decimal($event,objNotaCredito,'TipoCambio');" id="TipoCambio" class="form-control">
									<CValidation v-if="this.errorvalidacion.TipoCambio" :Mensaje="'*'+errorvalidacion.TipoCambio[0]"/>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="TipoRelacion">Tipo Relación</label>
									<select v-model="objNotaCredito.TipoRelacion" @change="BorrarUUID()" class="form-control form-select" id="TipoRelacion">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaTipoRelacion" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.TipoRelacion" :Mensaje="'*'+errorvalidacion.TipoRelacion[0]"/>
								</div>
								
								<div v-show="objNotaCredito.TipoRelacion!=''" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="IdDocumentoRelacionado">UUID</label>
									<input type="text" v-model="objNotaCredito.IdDocumentoRelacionado" class="form-control" id="IdDocumentoRelacionado" placeholder="Ingresar UUID" readonly />
									<CValidation v-if="this.errorvalidacion.IdDocumentoRelacionado" :Mensaje="'*'+errorvalidacion.IdDocumentoRelacionado[0]"/>
								</div>
							</div>

							<hr class="horizontal dark">

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-8 col-lg-2 col-xl-2">
									<h5>Conceptos</h5>
								</div>

								<div class="col-12 col-sm-12 col-md-8 col-lg-7 col-xl-7">
									<hr class="horizontal dark">
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 text-end">
									<button type="button" @click="AgregarConcepto()" class="btn btn-primary">
										<i class="fa fa-plus-circle"></i> Concepto
									</button>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<div class="table-responsive pb-0">
										<table class="table table-striped mb-0">
											<thead>
												<tr>
													<th width="3%">#</th>
													<th width="7%">Ret. Iva ({{objAgenos.RetencionIva}}%)</th>
													<th width="5%">Cantidad</th>
													<th width="13%"></th>
													<th width="14%">Seleccione</th>
													<th width="29%">Descripción</th>
													<th width="9%">Precio U.</th>
													<th width="4%">Descuento</th>
													<th width="13%">Importe</th>
													<th width="3%">*</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item,index) in ListaConceptosCredito" :key="index">
													<td>{{(index+1)}}</td>
													<td>
														<div class="form-check">
															<input type="checkbox" v-model="item.RetencionIva" @change="EjecutarCalculos()" :id="'flexCheckDefault_'+index" class="form-check-input">
															<label class="form-check-label" :for="'flexCheckDefault_'+index">
																Aplicar
															</label>
														</div>
													</td>
													<td>
														<input type="text" v-model="item.Cantidad" @input="$onlyNums($event,item,'Cantidad');EjecutarCalculos();" class="form-control form-control-sm" :readonly="(item.IdDetalleCotizacion>0)?true:false">
													</td>
													<td>
														<div class="row">
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2">
																<span>Clave Servicios</span>
															</div>
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2">
																<span>Clave Unidad</span>
															</div>
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2">
																<span>Objeto Impuesto</span>
															</div>
														</div>
													</td>
													<td>
														<div class="row">
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
																<select v-model="item.ClaveProdServ" class="form-control form-select">
																	<option value="">Seleccione</option>
																	<option v-for="(item2,index2) in ListaClavePyS" :key="index2" :value="item2.Clave">
																		{{item2.Clave+' - '+item2.Nombre}}
																	</option>
																</select>
															</div>

															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
																<select v-model="item.Unidad" class="form-control form-select">
																	<option value="">Seleccione</option>
																	<option v-for="(item2,index2) in ListaUnidadMedida" :key="index2" :value="item2.Clave+'~'+item2.Nombre">
																		{{item2.Nombre}}
																	</option>
																</select>
															</div>

															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
																<select v-model="item.ClaveObjImpuesto" class="form-control form-select">
																	<option value="">Seleccione</option>
																	<option v-for="(item2,index2) in ListaObjetoImp" :key="index2" :value="item2.Clave">
																		{{item2.Clave+' - '+item2.Nombre}}
																	</option>
																</select>
															</div>
														</div>
													</td>
													<td>
														<textarea v-model="item.Descripcion" class="form-control" rows="3"></textarea>
													</td>
													<td>
														<input type="text" v-model="item.Precio" @input="$number_decimal($event,item,'Precio');EjecutarCalculos();" class="form-control form-control-sm" :readonly="(item.IdDetalleCotizacion>0)?true:false">
													</td>
													<td>
														<input type="text" v-model="item.Descuento" @input="$number_decimal($event,item,'Descuento');EjecutarCalculos()" class="form-control form-control-sm">
													</td>
													<td>
														<input type="text" v-model="item.Importe" class="form-control form-control-sm" readonly>
													</td>
													<td>
														<button type="button" @click="BorrarItemConcepto(index)" class="btn btn-danger btnpequenio">
															<i class="fa fa-trash"></i>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<CValidation v-if="this.errorvalidacion.ArregloEventos" :Mensaje="'*'+errorvalidacion.ArregloEventos[0]"/>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8 mb-2">
									<label class="form-label" for="Observaciones">Observaciones</label>
									<textarea v-model="objNotaCredito.Observaciones" class="form-control" id="Observaciones" placeholder="Ingresar Observaciones" rows="3"></textarea>
									<CValidation v-if="this.errorvalidacion.Observaciones" :Mensaje="'*'+errorvalidacion.Observaciones[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4">
									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="Descuento">Descuento:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objNotaCredito.Descuento" class="form-control form-control-sm" id="Descuento" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="SubTotal">SubTotal:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objNotaCredito.SubTotal" class="form-control form-control-sm" id="SubTotal" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="ImporteT">Importe:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objAgenos.Importe" class="form-control form-control-sm" id="ImporteT" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="Iva">I.V.A {{objAgenos.TrasladoIva}}%:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objNotaCredito.Iva" class="form-control form-control-sm" id="Iva" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="RetencionIva">Ret. I.V.A ({{objAgenos.RetencionIva}}%):</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objNotaCredito.RetencionIva" class="form-control form-control-sm" id="RetencionIva" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="Total">Total:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objNotaCredito.Total" class="form-control form-control-sm" id="Total" readonly>
										</div>
									</div>
								</div>
							</div>

							<div class="row justify-content-end mt-4 mb-4">
								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 text-end mt-2">
									<span :class="['badge', (NumeroTimbres>0)?'bg-primary':'bg-danger']">Timbres Disponibles: {{NumeroTimbres}}</span>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<select v-model="objAgenos.Guardar" class="form-contorl form-select">
										<option value="1">Guardar</option>
										<template v-if="objNotaCredito.Facturado =='NO'">
											<template v-if="(NumeroTimbres>0)">
												<option value="2">Guardar y Facturar</option>
											</template>
										</template>
									</select>
								</div>
							</div>
													
							<br>
							<CBtnSave :poBtnSave="oBtnSave" />
						</form>

						<CModal :pConfigModal="ConfigModal1" :poBtnSave="oBtnSave1">
							<template slot="Form">
								<ListFacturas :poBtnSave="oBtnSave1"></ListFacturas>
							</template>
						</CModal>
					</div>
				</template>
			</CLoader>
		</template>
	</CList>
	
</template>
<script>
import ListFacturas from '@/views/modulos/finanzas/notaCredito/ListFacturas.vue';
const EmitEjecuta = 'seccionNotaCredito';
const EmitEjecuta1 = 'seccionClientes';

export default {
    name: 'FormNotaCredito',
    props: ['Id'],
    components:{
		ListFacturas
    },
    data() {
        return {
			ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'notacredito',
                EmitSeccion: EmitEjecuta,
            },
			ConfigModal1:{
                ModalTitle: "Listado de Facturas",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta1,
                ModalSize: 'xl',
				ShowFooter: false,
            },
            oBtnSave1: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta1,
            },
            objNotaCredito: {
				IdNotaCredito: 0,
				IdFactura: 0,
				IdEmpresa: 0,
				IdCliente: 0,
				IdUsuario: 0,
				FechaRegistro: '',
				Folio: '',
				Serie: '',
				NombreEmpresa: '',
				RegimenFiscalEmpresa: '',
				RfcEmpresa: '',
				CalleEmpresa: '',
				TelEmpresa: '',
				ColoniaEmpresa: '',
				CiudadEmpresa: '',
				PaisEmpresa: '',
				EstadoEmpresa: '',
				MunicipioEmpresa: '',
				CPEmpresa: '',
				NumExtEmpresa: '',
				NumIntEmpresa: '',
				NombreCliente: '',
				RfcCliente: '',
				TelCliente: '',
				CorreoCliente: '',
				CalleCliente: '',
				ColoniaCliente: '',
				CiudadCliente: '',
				PaisCliente: '',
				EstadoCliente: '',
				MunicipioCliente: '',
				CPCliente: '',
				NumExtCliente: '',
				NumIntCliente: '',
				TipoComprobante: 'E',
				SubTotal: '',
				Descuento: '',
				Iva: '',
				PorcentajeIva: '',
				Total: '',
				FormaPago: '',
				ClavePago: '',
				MetodoPago: '',
				CondicionesPago: '',
				NumCtaPago: '',
				Banco: '',
				TipoCambio: '',
				Moneda: '',
				Simbolo: '$',
				Facturado: 'NO',
				Adenda: '',
				Observaciones: '',
				UsoCfdi: '',
				DiasCredito: '',
				TipoRelacion: '',
				IdDocumentoRelacionado: '',
				EstatusCancel: '',
				RegimenFiscalCliente: '',
				VersionFact: '4.0',
				IdSucursal: 0,
				
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,

			ListaMetodoPago: [],
			ListaFormaPago: [],
			ListaUsodeCfdi: [],
			ListaMonedas: [],
			ListaTipoRelacion: [],
			ListaClavePyS: [],
			ListaUnidadMedida: [],
			ListaObjetoImp: [],
			ListaDocsRelacionados: [],
			ListaConceptosCredito: [],
			objAgenos: {
				Guardar: 1,
				Importe: '',
				RetencionIva: 6,
				ValorRetencion: 0,
				TrasladoIva: 16,
				ValorIva: 0,
			},
			NumeroTimbres: 0,
        }
    },
    methods :
    {
       	async Guardar()
        {
			let band1 = 0;
            let msg1 = '';

			if(this.ListaConceptosCredito.length == 0)
			{
				this.$toast.warning('Debe agregar al menos un concepto.')
				return false;
			}

			$.each(this.ListaConceptosCredito, function(key, value){
                if(value.Cantidad == ''){
                    msg1 = "El campo Cantidad de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
                else if(value.ClaveProdServ == ''){
                    msg1 = "El campo Clave de Servicios de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
				else if(value.Unidad == ''){
                    msg1 = "El campo Unidad de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
				else if(value.ClaveObjImpuesto == ''){
                    msg1 = "El campo Objeto de Impuesto de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
				else if(value.Descripcion == ''){
                    msg1 = "El campo Descripción de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
				else if(value.Precio == ''){
                    msg1 = "El campo Precio de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
            });
            if(band1>0){ this.$toast.warning(msg1); return false; }

			let ClavePago = '';
			let FormaPago = '';

			if(this.objNotaCredito.FormaPago!='')
			{
				let separe = this.objNotaCredito.FormaPago.split('~');
				ClavePago = separe[0];
				FormaPago = separe[1];
			}

			let TipoRelacion = (this.objNotaCredito.TipoRelacion =='')?'':this.objNotaCredito.TipoRelacion;

			let formData = new FormData();
			formData.set('IdNotaCredito', this.objNotaCredito.IdNotaCredito);
			formData.set('IdFactura', this.objNotaCredito.IdFactura);
			formData.set('IdEmpresa', this.objNotaCredito.IdEmpresa);
			formData.set('IdCliente', this.objNotaCredito.IdCliente);
			formData.set('IdUsuario', this.objNotaCredito.IdUsuario);
			formData.set('FechaRegistro', this.objNotaCredito.FechaRegistro);
			formData.set('Folio', this.objNotaCredito.Folio);
			formData.set('Serie', this.objNotaCredito.Serie);
			formData.set('NombreEmpresa', this.objNotaCredito.NombreEmpresa);
			formData.set('RegimenFiscalEmpresa', this.objNotaCredito.RegimenFiscalEmpresa);
			formData.set('RfcEmpresa', this.objNotaCredito.RfcEmpresa);
			formData.set('CalleEmpresa', this.objNotaCredito.CalleEmpresa);
			formData.set('TelEmpresa', this.objNotaCredito.TelEmpresa);
			formData.set('ColoniaEmpresa', this.objNotaCredito.ColoniaEmpresa);
			formData.set('CiudadEmpresa', this.objNotaCredito.CiudadEmpresa);
			formData.set('PaisEmpresa', this.objNotaCredito.PaisEmpresa);
			formData.set('EstadoEmpresa', this.objNotaCredito.EstadoEmpresa);
			formData.set('MunicipioEmpresa', this.objNotaCredito.MunicipioEmpresa);
			formData.set('CPEmpresa', this.objNotaCredito.CPEmpresa);
			formData.set('NumExtEmpresa', this.objNotaCredito.NumExtEmpresa);
			formData.set('NumIntEmpresa', this.objNotaCredito.NumIntEmpresa);
			formData.set('NombreCliente', this.objNotaCredito.NombreCliente);
			formData.set('RfcCliente', this.objNotaCredito.RfcCliente);
			formData.set('TelCliente', this.objNotaCredito.TelCliente);
			formData.set('CorreoCliente', this.objNotaCredito.CorreoCliente);
			formData.set('CalleCliente', this.objNotaCredito.CalleCliente);
			formData.set('ColoniaCliente', this.objNotaCredito.ColoniaCliente);
			formData.set('CiudadCliente', this.objNotaCredito.CiudadCliente);
			formData.set('PaisCliente', this.objNotaCredito.PaisCliente);
			formData.set('EstadoCliente', this.objNotaCredito.EstadoCliente);
			formData.set('MunicipioCliente', this.objNotaCredito.MunicipioCliente);
			formData.set('CPCliente', this.objNotaCredito.CPCliente);
			formData.set('NumExtCliente', this.objNotaCredito.NumExtCliente);
			formData.set('NumIntCliente', this.objNotaCredito.NumIntCliente);
			formData.set('TipoComprobante', this.objNotaCredito.TipoComprobante);

			let Descuento = this.objNotaCredito.Descuento;
			let SubTotal = this.objNotaCredito.SubTotal;
			let Iva = this.objNotaCredito.Iva;
			let PorcentajeIva = this.objNotaCredito.PorcentajeIva;
			let Total = this.objNotaCredito.Total;

			Descuento = (Descuento == '') ? 0 : Descuento;
			SubTotal = (SubTotal == '') ? 0 : SubTotal;
			Iva = (Iva == '') ? 0 : Iva;
			PorcentajeIva = (PorcentajeIva == '') ? (this.objAgenos.ValorIva == '')?0:this.objAgenos.ValorIva : PorcentajeIva;
			Total = (Total == '') ? 0 : Total;

			formData.set('SubTotal', SubTotal);
			formData.set('Descuento', Descuento);
			formData.set('Iva', Iva);
			formData.set('PorcentajeIva', PorcentajeIva);
			formData.set('Total', Total);

			formData.set('FormaPago', FormaPago);
			formData.set('ClavePago', ClavePago);
			formData.set('MetodoPago', this.objNotaCredito.MetodoPago);
			formData.set('CondicionesPago', this.objNotaCredito.CondicionesPago);
			formData.set('NumCtaPago', this.objNotaCredito.NumCtaPago);
			formData.set('Banco', this.objNotaCredito.Banco);
			formData.set('TipoCambio', this.objNotaCredito.TipoCambio);
			formData.set('Moneda', this.objNotaCredito.Moneda);
			formData.set('Simbolo', this.objNotaCredito.Simbolo);
			formData.set('Facturado', this.objNotaCredito.Facturado);
			formData.set('Adenda', this.objNotaCredito.Adenda);
			formData.set('Observaciones', this.objNotaCredito.Observaciones);
			formData.set('UsoCfdi', this.objNotaCredito.UsoCfdi);
			formData.set('DiasCredito', this.objNotaCredito.DiasCredito);
			formData.set('TipoRelacion', TipoRelacion);
			formData.set('IdDocumentoRelacionado', this.objNotaCredito.IdDocumentoRelacionado);
			formData.set('EstatusCancel', this.objNotaCredito.EstatusCancel);
			formData.set('RegimenFiscalCliente', this.objNotaCredito.RegimenFiscalCliente);
			formData.set('VersionFact', this.objNotaCredito.VersionFact);
			formData.set('IdSucursal', this.objNotaCredito.IdSucursal);

			formData.set('Guardar', this.objAgenos.Guardar);
			formData.set('Detalle', JSON.stringify(this.ListaConceptosCredito));
			
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
			
			await this.$http.post('notasCredito', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
			let obj = {
				message: res.data.message,
				typemsg: res.data.typemsg,
			};
			this.EjecutaMensajeAlerta(obj);
            // this.Regresar();
        },
        EjecutaConError(err)
        {
			this.oBtnSave.DisableBtn = false;
			// console.log(err.response.data)
			// SI DEVUELVE TYPEMSG CORRESPONDE A UN ERROR DE TIMBRADO, SINO CORRESPONDE A UN ERROR DE VALIDACION NORMAL
			if(err.response.data.typemsg)
			{
				this.bus.$emit('RunAlerts_'+this.Emit,3);
				this.EjecutaMensajeAlerta(err.response.data);
			}
			else
			{
				if(err.response.data.errors){
					this.errorvalidacion = err.response.data.errors;
					this.oBtnSave.Toast = 2;
				}
				else{
					this.$toast.error(err.response.data.message);
				}
			}
        },
		EjecutaMensajeAlerta(DataAlert)
		{
			//console.log(DataAlert);
			let Titulo = 'Se produjo un error al timbrar';
			let Mensaje = DataAlert.message;
			let Icon = 'warning';
			let Content = '';

			switch(DataAlert.typemsg)
			{
				case 3:

					let htmls = `
					<h3>Problemas detectados:</h3><br>
					<hr>
					<div class="card scrollCfdi">
						<div class="card-body">
							<ul class="list-group">`;
					
					$.each(DataAlert.errors.Error, function(key, value){
						htmls+=`<li class="list-group-item">`+value+`</li>`;
					});

					htmls+=`</ul>
						</div>
					</div>`;
					Content = htmls;

				break;

				case 1:
					Titulo = 'Facturado Exitosamente';
					Icon = 'success';
				break;

				case 0:
					Titulo = 'Información Guardada Correctamente';
					Icon = 'success';
				break;
			}

			this.$swal(
            {
                title: '<h2 style="font-size:25px; font-weight: 700;">'+Titulo+'</h2>',
                text: Mensaje,
				html: Content,
                icon: Icon,
                confirmButtonText: 'Aceptar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#00a389',
            });
			this.Regresar();
		},
		Recuperar()
        {
            this.$http.get(
                "notasCredito/"+this.objNotaCredito.IdNotaCredito
            ).then((res) => {
                this.objNotaCredito = res.data.data;
				let response = res.data.detalle;

				this.ListaConceptosCredito = response;

				let Union = this.objNotaCredito.ClavePago+'~'+this.objNotaCredito.FormaPago;
				this.objNotaCredito.FormaPago = Union;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
				this.EjecutarCalculos();
            });
        },
        Limpiar()
        {
            this.objNotaCredito = {
				IdNotaCredito: 0,
				IdFactura: 0,
				IdEmpresa: 0,
				IdCliente: 0,
				IdUsuario: 0,
				FechaRegistro: '',
				Folio: '',
				Serie: '',
				NombreEmpresa: '',
				RegimenFiscalEmpresa: '',
				RfcEmpresa: '',
				CalleEmpresa: '',
				TelEmpresa: '',
				ColoniaEmpresa: '',
				CiudadEmpresa: '',
				PaisEmpresa: '',
				EstadoEmpresa: '',
				MunicipioEmpresa: '',
				CPEmpresa: '',
				NumExtEmpresa: '',
				NumIntEmpresa: '',
				NombreCliente: '',
				RfcCliente: '',
				TelCliente: '',
				CorreoCliente: '',
				CalleCliente: '',
				ColoniaCliente: '',
				CiudadCliente: '',
				PaisCliente: '',
				EstadoCliente: '',
				MunicipioCliente: '',
				CPCliente: '',
				NumExtCliente: '',
				NumIntCliente: '',
				TipoComprobante: 'E',
				SubTotal: '',
				Descuento: '',
				Iva: '',
				PorcentajeIva: '',
				Total: '',
				FormaPago: '',
				ClavePago: '',
				MetodoPago: '',
				CondicionesPago: '',
				NumCtaPago: '',
				Banco: '',
				TipoCambio: '',
				Moneda: '',
				Simbolo: '$',
				Facturado: 'NO',
				Adenda: '',
				Observaciones: '',
				UsoCfdi: '',
				DiasCredito: '',
				TipoRelacion: '',
				IdDocumentoRelacionado: '',
				EstatusCancel: '',
				RegimenFiscalCliente: '',
				VersionFact: '4.0',
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
            // this.$router.push({name:'routeraregresar',params:{obj:this.obj}});
        },
		GetListCombosConfig()
		{
			this.$http.get(
                "getCombosfactura"
            ).then((res) => {
                this.ListaMetodoPago 	= res.data.MetodoPago;
				this.ListaFormaPago 	= res.data.FormaPago;
				this.ListaUsodeCfdi 	= res.data.UsoDeCfdi;
				this.ListaMonedas 		= res.data.Moneda;
				this.ListaTipoRelacion	= res.data.TipoRelacion;
				this.ListaClavePyS 		= res.data.ClavePyS;
				this.ListaUnidadMedida 	= res.data.UnidadMedida;
				this.ListaObjetoImp 	= res.data.ObjetoImp;

				let Impuesto = res.data.Impuestos;
				let Conceptos = res.data.ConceptosFYM;
				let Own = this;

				Impuesto.map(function(element){
					if(element.Nombre == 'Retencion IVA')
					{
						Own.objAgenos.RetencionIva = element.Impuesto;
						Own.objAgenos.ValorRetencion = element.ValorImpuesto
					}
					else
					{
						Own.objAgenos.TrasladoIva = element.Impuesto;
						Own.objAgenos.ValorIva = element.ValorImpuesto;
					}
				});

				Conceptos.map(function(element){
					if(element.Tipo == 'F'){
						Own.objAgenos.ClaveFloreria = element.CodigoSat;
					}else{
						Own.objAgenos.ClaveMontaje = element.CodigoSat;
					}
				});

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
				this.GetTimbresDisponibles();
            });
		},
		GetTimbresDisponibles()
		{
			this.$http.get(
                "getTimbresfactura"
            ).then((res) => {
				//console.log(res.data)
				this.NumeroTimbres = res.data.timbres;
			}).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
		},
		AbrirModalFacturas()
		{
			this.bus.$emit('NewModal_'+EmitEjecuta1,0);
		},
		SetearDataFactura(obj)
		{
			console.log('-----');
			console.log(obj);
			this.objNotaCredito.IdFactura 		= obj.IdFactura;
			this.objNotaCredito.IdCliente 		= obj.IdCliente;
			this.objNotaCredito.NombreCliente 	= obj.NombreCliente;
			this.objNotaCredito.RfcCliente 		= obj.RfcCliente;
			this.objNotaCredito.FolioFactura 	= obj.Folio;
			this.objNotaCredito.CalleCliente 	= obj.CalleCliente;
			this.objNotaCredito.NumExtCliente 	= obj.NumExtCliente;
			this.objNotaCredito.NumIntCliente 	= obj.NumIntCliente;
			this.objNotaCredito.ColoniaCliente 	= obj.ColoniaCliente;
			this.objNotaCredito.CPCliente 		= obj.CPCliente;
			this.objNotaCredito.PaisCliente 	= obj.PaisCliente;
			this.objNotaCredito.EstadoCliente 	= obj.EstadoCliente;
			this.objNotaCredito.CiudadCliente 	= obj.CiudadCliente;
			this.objNotaCredito.RegimenFiscalCliente = obj.RegimenFiscalCliente;
			this.objNotaCredito.MunicipioCliente= obj.MunicipioCliente;
			this.objNotaCredito.TelCliente 		= obj.TelCliente;
			this.objNotaCredito.CorreoCliente 	= obj.CorreoCliente;

			this.objNotaCredito.IdDocumentoRelacionado = obj.UUID;

			let TipoRel = this.ListaTipoRelacion.filter(function(item){
				if(item.Clave == '01'){
					return item;
				}
			});

			if(TipoRel[0]){
				this.objNotaCredito.TipoRelacion = TipoRel[0].Clave+'~'+TipoRel[0].Nombre;
			}
		},
		AgregarConcepto()
		{
			let obj = {
				IdDetalleCredito: 0,
				IdNotaCredito: 0,
				IdDetalleCotizacion: 0,
				Cantidad: '',
				ClaveProdServ: '',
				Unidad: '',
				ClaveObjImpuesto: '',
				Descripcion: '',
				Precio: '',
				Descuento: 0,
				Importe: '',

				RetencionIva: false,
				PrecioDefault: 0,
				TipoMoneda: 'MXN',
				TasaRetIva: 0,
				ImporteRetIva: 0,
			};

			this.ListaConceptosCredito.push(obj);
		},
		BorrarItemConcepto(index)
		{
			this.ListaConceptosCredito.splice(index, 1);
			this.EjecutarCalculos();
		},
		EjecutarCalculos()
        {
			let SubTotal = 0;
			let ImporteTotal = 0;
            let Iva = this.objAgenos.ValorIva;
            let RetencionP = this.objAgenos.ValorRetencion;
            let Total = 0;
			let TotalRetencion = 0;
			let TotalDescuento = 0;
            let Arreglo = this.ListaConceptosCredito;
           

            for(let i=0; i<Arreglo.length; i++)
            {
				let ValorRetencion = 0;
				let ValorDescuento = 0;

				if(Arreglo[i].RetencionIva){
					ValorRetencion = RetencionP;
				}
				if(Arreglo[i].Descuento>0){
					ValorDescuento = parseFloat(Arreglo[i].Descuento);
				}

                let Cantidad = Arreglo[i].Cantidad;
                let PrecioUn = Arreglo[i].Precio;

				Cantidad = (Cantidad!='') ? Cantidad : 0;
				PrecioUn = (PrecioUn!='') ? PrecioUn : 0;

                Cantidad = (isNaN(Cantidad)) ? 0 : parseFloat(Cantidad);
                PrecioUn = (isNaN(PrecioUn)) ? 0 : parseFloat(PrecioUn);

				let Importe = parseFloat(Cantidad*PrecioUn);
				Importe = (isNaN(Importe)) ? 0 : parseFloat(Importe);
				Arreglo[i].Importe = Importe.toFixed(2);

				// SUMA DE TODOS LOS IMPORTES DA EL SUBTOTAL
                SubTotal+= Importe;

				// SE SUMAN TODOS LOS DESCUENTOS
				TotalDescuento+= ValorDescuento;

				// CALCULAMOS LA RETENCION POR PARTIDA
				// IMPORTE - DESCUENTOS INDIVIDUALES * PORCENTAJE DE LA RETENCION
				let IvaRetencion = parseFloat(Importe-ValorDescuento)*parseFloat(ValorRetencion);
				IvaRetencion = (isNaN(IvaRetencion)) ? 0 : IvaRetencion;
				TotalRetencion+= IvaRetencion;
				
				if(Arreglo[i].TasaRetIva != undefined){
					Arreglo[i].TasaRetIva = ValorRetencion;
					Arreglo[i].ImporteRetIva = IvaRetencion;
				}
            }

			// EL SUBTOTAL ES LA SUMA DE TODOS LOS IMPORTES
            TotalDescuento = (isNaN(TotalDescuento)) ? 0 : TotalDescuento;
            SubTotal = (isNaN(SubTotal)) ? 0 : SubTotal;

			// EL IMPORTE ES EL SUBTOTAL MENOS LOS DESCUENTOS
			ImporteTotal = parseFloat(SubTotal)-parseFloat(TotalDescuento);
			ImporteTotal = (isNaN(ImporteTotal)) ? 0 : ImporteTotal;

			// EL IVA ES EL IMPORTE POR EL PORCENTAJE DE IVA
            Iva = parseFloat(ImporteTotal)*parseFloat(Iva);
            Iva = (isNaN(Iva)) ? 0 : Iva;
            Total = parseFloat(ImporteTotal)+parseFloat(Iva)-parseFloat(TotalRetencion);

			//this.objEvento.Iva 			= 16;
            this.objNotaCredito.Descuento	= parseFloat(TotalDescuento).toFixed(2);
            this.objNotaCredito.SubTotal	= parseFloat(SubTotal).toFixed(2);
			this.objAgenos.Importe			= parseFloat(ImporteTotal).toFixed(2);
            this.objNotaCredito.Iva 		= parseFloat(Iva).toFixed(2);
            this.objNotaCredito.Total		= parseFloat(Total).toFixed(2);
            this.objNotaCredito.RetencionIva= parseFloat(TotalRetencion).toFixed(2);
        },
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
        this.bus.$off('AgregarFacturaCredito');
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
		this.GetListCombosConfig();

        if(this.Id!='') 
        {
            this.objNotaCredito.IdNotaCredito = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('AgregarFacturaCredito',(obj)=>
        {
            this.SetearDataFactura(obj);
        });
    }
}
</script>
